import React from "react"
import {
  FacebookShareButton,
  LinkedinShareButton,
  RedditShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  RedditIcon,
} from "react-share"

const Sharer = ({ url, title }) => (
  <div>
    <FacebookShareButton url={url} quote={title} className="sharer-icon">
      <FacebookIcon size={32} round />
    </FacebookShareButton>

    <TwitterShareButton url={url} title={title} className="sharer-icon">
      <TwitterIcon size={32} round />
    </TwitterShareButton>

    <LinkedinShareButton url={url} className="sharer-icon">
      <LinkedinIcon size={32} round />
    </LinkedinShareButton>

    <RedditShareButton
      url={url}
      title={title}
      windowWidth={660}
      windowHeight={460}
      className="sharer-icon"
    >
      <RedditIcon size={32} round />
    </RedditShareButton>
  </div>
)
export default Sharer
